import React, { ReactElement, useContext } from 'react'
import classnames from 'classnames'
import { useTranslations } from 'next-intl'
import { Link } from '../Link/Link'
import style from './CustomError.module.css'
import { ROUTES } from '../../routes/routes'
import { LocaleContext } from '../LocaleContext/LocaleContext'

const CONFIRMED_CONCATENATION_TEXT = 'app.formComponents.form.email.validation.alreadyExists.concatenationText'
const ALREADY_EXISTS_LINK_LOGON = 'app.formComponents.form.email.validation.alreadyExists.linkToLogon'
const ALREADY_EXISTS_LINK_RESTORE_PASSWORD =
  'app.formComponents.form.email.validation.alreadyExists.linkToRestorePassword'

type CustomErrorProps = {
  error?: string
  isBusy?: boolean
  touched?: boolean
  login: string
}

export const CustomError = ({ error = '', isBusy, login, touched }: CustomErrorProps): ReactElement => {
  const t = useTranslations()
  const { locale } = useContext(LocaleContext)
  const confirmedConcatenationText = t(CONFIRMED_CONCATENATION_TEXT)
  const alreadyExistsLinkLogon = t(ALREADY_EXISTS_LINK_LOGON)
  const alreadyExistsLinkRestorePassword = t(ALREADY_EXISTS_LINK_RESTORE_PASSWORD)
  // TODO надо проверить правильность параметра lang
  const resetLink = `${ROUTES.LOGON_PAGE}?lang=${locale}&login=${login}`

  const errorClassNames = classnames(touched && error ? style.errorMessage : style.errorMessageDefault)

  return (
    <div>
      {Boolean(error) && <div className={errorClassNames}>{t(error)}</div>}
      {isBusy && (
        <div>
          <Link className={style.link} href={resetLink}>
            {alreadyExistsLinkLogon}
          </Link>
          <span className={style.or}>{` ${confirmedConcatenationText} `}</span>
          <Link className={style.link} href={resetLink}>
            {alreadyExistsLinkRestorePassword}
          </Link>
        </div>
      )}
    </div>
  )
}

CustomError.displayName = 'CustomError'
